import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export default function useGetUsers({ teamId }: { teamId: string }) {
  const fetchData = async () => {
    const response = await httpClient.get(`team/team/users`, {
      headers: {
        'X-Team': teamId,
      },
    })
    return response.data.users
  }

  return useQuery({
    queryKey: ['users', teamId],
    queryFn: fetchData,
    staleTime: Infinity,
  })
}
